import { withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button } from '#shared/components/UI';
import { AccountSearchParams } from '../types';
import useAccountSearchFormConfig from './useAccountSearchFormConfig';
import styles from './AccountSearchForm.module.scss';

const cn = withStyles(styles);

export type AccountSearchFormProps = {
  /** The filters currently in the URL — the form seeds and re-seeds from these. */
  searchParams: AccountSearchParams;
  onSearch: (searchParams: AccountSearchParams) => void;
};

export default function AccountSearchForm({ searchParams, onSearch }: AccountSearchFormProps) {
  const { t: tButtons } = useTranslation('translations', { keyPrefix: 'Shared.Buttons' });
  const { ctx, renderFormElements } = useAccountSearchFormConfig({ initialValues: searchParams, onSubmit: onSearch });

  return (
    // A real <form>: the keyword box is a single-field search, so Enter has to submit it. It was a
    // Box of inputs beside an onClick button, where pressing Enter did nothing at all.
    <form className={cn('form')} onSubmit={ctx.handleSubmit}>
      <div className={cn('filters')}>{renderFormElements()}</div>

      <Button id="search-bankAccount" type="submit" size="small" colorScheme="primary">
        {tButtons('search', { defaultValue: 'Search' })}
      </Button>
    </form>
  );
}
